import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Header, ImageService } from '../image.service';

export class FileHolder {
  public serverResponse: { status: number, response: any };
  public pending: boolean = false;

  constructor(public src: string, public file: File) {
  }
}

@Component({
  selector: 'image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class ImageUploadComponent implements OnInit {
  @Input() max: number = 100;
  @Input() url: string;
  @Input() headers: Header[];
  @Input() preview: boolean = true;
  @Input() maxFileSize: number;
  @Input() withCredentials: boolean = false;
  @Input() partName: string;

  @Output()
  isPending: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  onFileUploadFinish: EventEmitter<FileHolder> = new EventEmitter<FileHolder>();
  @Output()
  onRemove: EventEmitter<FileHolder> = new EventEmitter<FileHolder>();

  files: FileHolder[] = [];
  showFileTooLargeMessage: boolean = false;
  fileCounter: number = 0;
  isFileOver: boolean = false;

  @Input()
  buttonCaption: string = 'Select Images';
  @Input()
  dropBoxMessage: string = 'Drop your images here!';
  @Input()
  fileTooLargeMessage: string;
  @Input('extensions')
  supportedExtensions: string[];

  public pendingFilesCounter: number = 0;
  @ViewChild('input')
  public inputElement: ElementRef;

  constructor(public imageService: ImageService) {
  }

  ngOnInit() {
    if (!this.fileTooLargeMessage) {
      this.fileTooLargeMessage = 'An image was too large and was not uploaded.' + (this.maxFileSize ? (' The maximum file size is ' + this.maxFileSize / 1024) + 'KiB.' : '');
    }

    if (this.supportedExtensions.length !== 0 ) {
      for (let i = 0; i < this.supportedExtensions.length; i++) {
        if (this.supportedExtensions[i] === 'jpeg' || this.supportedExtensions[i] === 'png') {
          this.supportedExtensions[i] = 'image/' + this.supportedExtensions[i];
        } else if (this.supportedExtensions[i] === 'csv') {
          this.supportedExtensions[i] = 'text/' + this.supportedExtensions[i];
        } else if (this.supportedExtensions[i] === 'txt') {
          this.supportedExtensions[i] = 'text/plain';
        }else if (this.supportedExtensions[i] === 'doc') {
          this.supportedExtensions[i] = 'application/msword';
        } else if (this.supportedExtensions[i] === 'docx') {
          this.supportedExtensions[i] = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        } else if (this.supportedExtensions[i] === '3gp') {
          this.supportedExtensions[i] = 'video/3gpp';
        } else if (this.supportedExtensions[i] === '3g2') {
          this.supportedExtensions[i] = 'video/3gpp2';
        } else if (this.supportedExtensions[i] === 'mp4') {
          this.supportedExtensions[i] = 'video/' + this.supportedExtensions[i];
        } else if (this.supportedExtensions[i] === 'pdf') {
          this.supportedExtensions[i] = 'application/' + this.supportedExtensions[i];
        }
      }
    } else {
      this.supportedExtensions = ['image/*'];
    }
  }

  fileChange(files: FileList) {
    const remainingSlots = this.countRemainingSlots();
    const filesToUploadNum = files.length > remainingSlots ? remainingSlots : files.length;

    if (this.url && filesToUploadNum != 0) {
      this.isPending.emit(true);
    }

    this.fileCounter += filesToUploadNum;
    this.showFileTooLargeMessage = false;
    this.uploadFiles(files, filesToUploadNum);
  }

  deleteFile(file: FileHolder): void {
    const index = this.files.indexOf(file);
    this.files.splice(index, 1);
    this.fileCounter--;
    // this.inputElement.nativeElement.value = '';

    this.onRemove.emit(file);
  }

  deleteAll() {
    this.files.forEach(f => this.onRemove.emit(f));

    this.files = [];
    this.fileCounter = 0;
    // this.inputElement.nativeElement.value = '';
  }

  fileOver(isOver) {
    this.isFileOver = isOver;
  }

  public uploadFiles(files: FileList, filesToUploadNum: number) {
    for (let i = 0; i < filesToUploadNum; i++) {
      const file = files[i];

      if (this.maxFileSize && file.size > this.maxFileSize) {
        this.showFileTooLargeMessage = true;
        this.fileCounter = this.fileCounter - 1;
        continue;
      }

      const img = document.createElement('img');
      img.src = window.URL.createObjectURL(file);

      const reader = new FileReader();
      reader.addEventListener('load', (event: any) => {
        const fileHolder: FileHolder = new FileHolder(event.target.result, file);

        this.uploadSingleFile(fileHolder);

        this.files.push(fileHolder);

      }, false);


      reader.readAsDataURL(file);
    }
  }

  public onResponse(response, fileHolder: FileHolder) {
    fileHolder.serverResponse = response;
    fileHolder.pending = false;

    this.onFileUploadFinish.emit(fileHolder);

    if (--this.pendingFilesCounter == 0) {
      this.isPending.emit(false);
    }
  }

  public uploadSingleFile(fileHolder: FileHolder) {
    if (this.url) {
      this.pendingFilesCounter++;
      fileHolder.pending = true;

      this.imageService
        .postImage(this.url, fileHolder.file, this.headers, this.partName, this.withCredentials)
        .subscribe(
          response => this.onResponse(response, fileHolder),
          error => {
            this.onResponse(error, fileHolder);
            this.deleteFile(fileHolder);
          }
        );
    } else {
      this.onFileUploadFinish.emit(fileHolder);
    }
  }

  public countRemainingSlots() {
    return this.max - this.fileCounter;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/angular2-image-upload/image-upload/image-upload.component.ts